module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABHNCSVQICAgIfAhkiAAAAStJREFUaEPtmDsSwjAMRPHQcBxoqaDnQuYA4UIcgIqa49AwxnFSUJA8JhqRMWxaWZ/dlcZywqLyL1Re/0IA5lZQCkgBIwNqoVECY7oW+ylsjUQPuvsqENO9B7CqE8AxpVJ4E9yIcgtcChcAbrw/VyCmW96mUu7xzVuuqIXInwUwLnNUoNUuAMSAlWHyp/zZPj7EMV3ymZRv0v2kHqcCyU75EQAlmNsuAFIAdiUiSC1EDHnbpYA3wxRfChBD3nZUoLvK20f5bsZVYjg/AqBl6gsMUwm2F5kA2P9a2BRon4TdjKwnzQj5U/+YZ4ASUIuR/wd2mwKUQACIIXpSsv/4iR9Q4FEQNmFp5WLI33sGzj2AQ50AvKp+ieurgAAwA1KAOfI9IQV8+eXo1SvwBMdqJEAdOqoCAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/housework/btn_voice.png
// module id = qkx/
// module chunks = 5